import S from './InquiryBanner.module.scss';
import { StoreBannerItem } from './types';
interface StoreBannerImageProps {
  bannerData: StoreBannerItem;
}
export const StoreBannerImage = ({
  bannerData
}: StoreBannerImageProps) => {
  const {
    imageSrc
  } = bannerData;
  return <img src={imageSrc} alt="banner_image" className={S.banner_image} data-sentry-component="StoreBannerImage" data-sentry-source-file="StoreBannerImage.tsx" />;
};